import type { API } from '@grafana/faro-web-sdk';
import type { Store, Unsubscribe } from '@reduxjs/toolkit';

import type { RootState } from '../../app/store';

type FaroUserApi = Pick<API, 'setUser' | 'resetUser'>;

export const bindFaroUser = (
  store: Pick<Store<RootState>, 'getState' | 'subscribe'>,
  api: FaroUserApi | undefined,
): Unsubscribe => {
  const getPlayerId = () => store.getState().auth.user?._id;

  let currentId: string | undefined;

  const sync = () => {
    const nextId = getPlayerId();
    if (nextId === currentId) return;

    currentId = nextId;
    if (nextId) {
      api?.setUser({ id: nextId });
    } else {
      api?.resetUser();
    }
  };

  sync();
  return store.subscribe(sync);
};
